import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useSubvalueCellStyles = makeStyles(
  (theme) => ({
    value: {
      marginBottom: theme.spacing(0.75)
    },
    subvalue: {
      color: theme.palette.textSubtle,
      fontWeight: "normal"
    }
  }),
  { name: "BackstageSubvalueCell" }
);
function SubvalueCell(props) {
  const { value, subvalue } = props;
  const classes = useSubvalueCellStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: classes.value }, value), /* @__PURE__ */ React.createElement(Box, { className: classes.subvalue }, subvalue));
}

export { SubvalueCell };
//# sourceMappingURL=SubvalueCell.esm.js.map
